import {useMemo} from "react";
import {getDistrict} from "../utils/SchoolBlocksUtilities";
import useSWR from "swr";
import WatsonApi from "../backends/WatsonApi";
import {isDescendantOrEq} from "../utils/DataUtilities";
import {useStores} from "../stores/useStores";

export const enum searchEnum {
    STATIC_CALENDAR = "static-calendar",
    STATIC_CALENDAR_URL = "/calendar",
    STATIC_CONTACT_US = "static-contact",
}

export default function usePagesSearch(searchTerm: string) {
    const {organizationStore} = useStores();

    const district = useMemo(() => getDistrict(organizationStore.organization), []);

    return useSWR(`search-pages-${searchTerm}`, async () => {
        if (searchTerm === "") {
            return []
        }

        const client = await WatsonApi();
        const response = await client.apis.organizations.organizations_list({
            path__descendant_or_eq: district.path,
            type__in: ["section", "department", "collection", "group", "school", "district"],
            omit: ["url", "hostname"],
            search: searchTerm,
            deleted: "false",
            ordering: "title",
            page_size: 10,
            path_descendant_of_district_or_school: organizationStore.organization.path,
            expand: ["title_organization"],
            published: 1,
        })

        return JSON.parse(response.data).data.map(r => {
            const showTitleOrganizationLabel = organizationStore.organization.type === "district" && !isDescendantOrEq(organizationStore.organization.path, r.path) && r.title_organization.type === 'school'
            const title_organization_label = ` (${r.title_organization.title})`
            const showDistrictLabel = organizationStore.organization.type === "school" &&
                !isDescendantOrEq(r.path, organizationStore.organization.path)
            return {
                text: `${r.title}${showDistrictLabel ? (" (District) ") : (showTitleOrganizationLabel ? title_organization_label : "")}`,
                key: r.id,
                value: r.id,
            }
        }).concat([
            {
                text: "Calendar (main page)",
                key: searchEnum.STATIC_CALENDAR,
                value: searchEnum.STATIC_CALENDAR_URL,  // TODO: how do we make this locale-aware?
            },
            {
                text: "Contact (organization modal)",
                key: searchEnum.STATIC_CONTACT_US,
                value: organizationStore.organization.id,
            },
        ]
            .filter(v => new RegExp(searchTerm, "gmi").test(v.text)))
            .sort((a, b) => a.text - b.text) || [];
    });
}
